export default {
	FOLDER_SELECTION: 'folderSelection',
	EMAIL_INITIAL: 'Email_Initial',
	TOTAL_SIZE: 'totalSize',
	EMAIL_UNREAD_1: 'Email_Unread_1',
	EMAIL_UNREAD_2: 'Email_Unread_2'
};
